import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { AccessoryPartItem } from "../../../queries/useSearchAccessoriesByVehicle";
import { Section } from "../../../ui/Section/Section";
import { SectionHeading } from "../Common/SectionHeading";

type AccessoryDescriptionProps = {
  part: AccessoryPartItem | null;
};

export const AccessoryDescription: FunctionComponent<
  AccessoryDescriptionProps
> = ({ part }) => {
  const [language] = useLanguage();
  const description =
    part?.partDetails.primaryPart.accessoryDescription[language];
  if (!description) {
    return null;
  }
  return (
    <Section>
      <SectionHeading translation="searchResults.description" />
      <p className="text-xs">{description}</p>
    </Section>
  );
};
